// extracted by mini-css-extract-plugin
export default {"error":"ChangePassword_error__vRp3m","formWrapper":"ChangePassword_formWrapper__a5N8b"};